var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-data-table", {
    attrs: {
      "custom-filter": _vm.filterOverAllProperty,
      headers: _vm.headers,
      items: _vm.bookings,
      loading: _vm.$store.getters["Ajax/loading"] ? "accent" : false,
      "sort-by": _vm.pagination.sortBy,
      "sort-desc": _vm.pagination.descending,
      search: _vm.search,
      "items-per-page": 5
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.pagination, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.pagination, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.pagination, "descending", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.pagination, "descending", $event)
      }
    },
    scopedSlots: _vm._u(
      [
        {
          key: "item",
          fn: function(props) {
            return [
              _c("tr", [
                _c("td", {}, [
                  _vm._v(_vm._s(_vm.formatDateView(props.item.creation_date)))
                ]),
                _c(
                  "td",
                  [
                    _vm._v(" " + _vm._s(props.item.reservation_number) + " "),
                    props.item.is_cancelled === 1
                      ? _c(
                          "v-chip",
                          {
                            staticStyle: {
                              color: "#FFE3F3",
                              "background-color": "#ff99d0 !important"
                            },
                            attrs: { label: "", outlined: "", small: "" }
                          },
                          [_vm._v(_vm._s(_vm.$t("booking.canceled")) + " ")]
                        )
                      : _vm._e(),
                    _c("assigned-delegations-chip", {
                      attrs: { delegations: props.item.delegations }
                    })
                  ],
                  1
                ),
                _c(
                  "td",
                  { staticClass: "py-2" },
                  [
                    props.item.hotelAttributes.vendor != null ||
                    props.item.hotelAttributes.address != null ||
                    props.item.hotelAttributes.hotel_phone_number !== null
                      ? [
                          _c(
                            "span",
                            { staticClass: "accent--text font-weight-bold" },
                            [_vm._v(_vm._s(props.item.hotelAttributes.vendor))]
                          ),
                          _c("br"),
                          _c("span", { staticClass: "grey--text" }, [
                            _vm._v(_vm._s(props.item.hotelAttributes.address))
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          props.item.hotelAttributes.hotel_phone_number !== null
                            ? _c(
                                "span",
                                {
                                  staticClass: "grey--text",
                                  staticStyle: { "font-weight": "bold" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("global.phoneNumber")) +
                                      ": " +
                                      _vm._s(
                                        props.item.hotelAttributes
                                          .hotel_phone_number
                                      )
                                  )
                                ]
                              )
                            : _vm._e()
                        ]
                      : [
                          _c("span", { staticClass: "grey--text" }, [
                            _vm._v(_vm._s(_vm.$t("global.noData")))
                          ])
                        ]
                  ],
                  2
                ),
                _c(
                  "td",
                  { staticClass: "font-weight-bold" },
                  [
                    props.item.hotelAttributes.start_date != null ||
                    props.item.hotelAttributes.end_date != null
                      ? [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.formatDateView(
                                  props.item.hotelAttributes.start_date
                                )
                              )
                          ),
                          _c("br"),
                          _vm._v(
                            _vm._s(
                              _vm.formatDateView(
                                props.item.hotelAttributes.end_date
                              )
                            ) + " "
                          )
                        ]
                      : [_vm._v(_vm._s(_vm.$t("global.noData")))]
                  ],
                  2
                ),
                _c(
                  "td",
                  {},
                  _vm._l(props.item.passengers, function(passenger) {
                    return _c(
                      "span",
                      { staticStyle: { "text-transform": "capitalize" } },
                      [_vm._v(" " + _vm._s(passenger) + " "), _c("br")]
                    )
                  }),
                  0
                ),
                _c(
                  "td",
                  { staticClass: "datatable-total-amount" },
                  [
                    props.item.invoice_gross_value !== null
                      ? [
                          _vm._v(
                            _vm._s(props.item.invoice_gross_value) +
                              " " +
                              _vm._s(props.item.invoice_currency)
                          )
                        ]
                      : props.item.total_amount !== null
                      ? [_vm._v(_vm._s(props.item.total_amount) + " PLN")]
                      : _vm._e()
                  ],
                  2
                ),
                _vm.$store.state.Auth.isWnt === false
                  ? _c("td", [
                      _vm._v(
                        _vm._s(
                          props.item.hotelAttributes.primitive_exchange_rate
                        )
                      )
                    ])
                  : _vm._e(),
                _c(
                  "td",
                  { staticClass: "text-center text-no-wrap" },
                  [
                    _vm._t(
                      "action-column",
                      [
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          {
                                            staticClass: "mx-0",
                                            attrs: {
                                              to:
                                                "/booking/other/detail/" +
                                                props.item.id,
                                              icon: ""
                                            }
                                          },
                                          on
                                        ),
                                        [
                                          _c("v-icon", [
                                            _vm._v("remove_red_eye")
                                          ])
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("global.goToDetails")) + " "
                            )
                          ]
                        ),
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          {
                                            staticClass: "mx-0",
                                            attrs: {
                                              disabled:
                                                _vm.$store.getters[
                                                  "Ajax/loading"
                                                ],
                                              icon: ""
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.downloadAttachment(
                                                  props.item.id
                                                )
                                              }
                                            }
                                          },
                                          on
                                        ),
                                        [
                                          _c("v-icon", [
                                            _vm._v("cloud_download")
                                          ])
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("global.downloadFile")) + " "
                            )
                          ]
                        )
                      ],
                      { booking: props.item }
                    )
                  ],
                  2
                )
              ])
            ]
          }
        }
      ],
      null,
      true
    )
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }